/*
 * Purpose: Primary site navigation SSOT — P0 AppShell
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { PRODUCT_TERMS } from '@/lib/productTerms';

export type PrimaryNavId = 'dashboard' | 'compose' | 'flows' | 'mission' | 'connect';

export interface PrimaryNavItem {
  id: PrimaryNavId;
  label: string;
  href: string;
  description: string;
}

export const PRIMARY_NAV: PrimaryNavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    href: '/dashboard',
    description: 'Command center — live runs and flow survey',
  },
  {
    id: 'compose',
    label: 'Compose',
    href: '/compose',
    description: PRODUCT_TERMS.autoBlockFlowComposer,
  },
  {
    id: 'flows',
    label: 'Flows',
    href: '/flows',
    description: 'My saved flows and Flow Templates library',
  },
  {
    id: 'mission',
    label: PRODUCT_TERMS.mission,
    href: '/mission/map',
    description: 'Map, run controls, operate and insights',
  },
  {
    id: 'connect',
    label: 'Connect',
    href: '/connect',
    description: 'Setup, secrets vault, connector library',
  },
];

export function matchPrimaryNav(pathname: string): PrimaryNavId | null {
  if (pathname.startsWith('/dashboard')) return 'dashboard';
  if (pathname.startsWith('/compose')) return 'compose';
  if (pathname.startsWith('/flows')) return 'flows';
  if (pathname.startsWith('/mission')) return 'mission';
  if (pathname.startsWith('/connect') || pathname.startsWith('/setup')) return 'connect';
  return null;
}

export const PROTECTED_ROUTE_PREFIXES = [
  '/dashboard',
  '/compose',
  '/flows',
  '/mission',
  '/connect',
  '/admin',
] as const;

export function isProtectedRoute(pathname: string): boolean {
  return PROTECTED_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
